import { render, staticRenderFns } from "./DefaultMessage.vue?vue&type=template&id=6460ca71&scoped=true"
import script from "./DefaultMessage.vue?vue&type=script&lang=js"
export * from "./DefaultMessage.vue?vue&type=script&lang=js"
import style0 from "./DefaultMessage.vue?vue&type=style&index=0&id=6460ca71&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460ca71",
  null
  
)

export default component.exports